/// REDUX ///
import { Dispatch } from "redux";
/// ACTION ///
import { Action } from "api/action_types/history";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/history";
/// TYPES ///
import { IHistory } from "api/types/history";

export const replaceRestorePoint = (history: IHistory) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.REPLACE_RESTORE_POINT,
      history
    });
  }
}
